import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {},
  form: {
    width: '100%',
  },
  tooltip: {
    fontSize: '10px',
    lineHeight: 'auto',
    height: '56px',
  },
  formContainer: {
    backgroundColor: '#ffffff',
    borderRadius: '4px 4px 4px 4px',
    padding: '32px',
    width: '100%',
  },
  block: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  desc: {
    width: '30%',
    fontSize: 16,
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  loginDateWraper: {
    padding: theme.spacing(0, 40, 0, 0),
  },
  blockMulti: {
    padding: theme.spacing(0, 4, 0, 0),
    '@media (max-width: 1399px)': {
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },
  title: {
    padding: '0 0 5px',
    fontSize: 14,
    letterSpacing: 0.15,
    opacity: 0.7,
    width: 300,
  },
  input: {
    minWidth: 250,
    flexGrow: 1,
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgb(0 0 0 / 87%)',
    },
  },
  descNoborder: {
    fontSize: 16,
    minWidth: 250,
    flexGrow: 1,
    padding: 5,
    color: 'rgb(0 0 0 / 54%)',
  },
  rowMulti: {
    minWidth: 250,
    flexGrow: 1,
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  descMulti: {
    fontSize: 16,
    minWidth: 250,
    flexGrow: 1,
    padding: '6px 0 7px',
    color: 'rgb(0 0 0 / 87%)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
  },
  descBox: {
    minWidth: 250,
    flexGrow: 1,
  },
  dark: {
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
  },
  gridPaper: {
    height: '100%',
  },
  tabsPanel: {
    width: '60%',
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(2),
  },
  btn: {
    padding: '15px 22px',
    fontSize: 15,
    backgroundColor: '#E2222B',
    fontWeight: 500,
    lineHeight: '26px',

    letterSpacing: '0.46px',
    textTransform: 'capitalize',

    color: '#FFFFFF',
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '16px 0 32px',
  },
  heading: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '133.4%',
    color: '#000000',
    margin: '24px 0',
    background: '#F6F6F6',
    padding: '10px 16px',
  },
  horizontalLine: {
    width: '100%',
    height: '1px',
    borderTop: '1px dashed #E0E0E0',
    margin: '30px 0',
  },
  leftCol: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '24px',
  },
  rightCol: {
    width: '100%',
  },

  profilePicture: {
    borderRadius: '50%',
    width: 100,
    height: 100,
  },
  profileContainer: {
    minWidth: '100px',
    borderRadius: '50%',
    marginRight: '24px',
  },
  uploadBtnContainer: {
    minWidth: '216px',
    gap: '12px',
    borderRadius: '4px',
    marginRight: '24px',
  },
  removeBtnContainer: {
    width: '107px',
    gap: '12px',
    borderRadius: '4px',
    marginRight: '24px',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
  link2: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    padding: '12px 24px',
  },
}));
